module.exports = __webpack_public_path__ + "static/1359773793.94011513.jpg";